var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 11C9.42297 11 11.668 8.755 11.668 6C11.668 3.245 9.42297 1 6.66797 1C3.91297 0.999999 1.66797 3.245 1.66797 6C1.66797 8.755 3.91297 11 6.66797 11ZM7.04297 8C7.04297 8.205 6.87297 8.375 6.66797 8.375C6.46297 8.375 6.29297 8.205 6.29297 8L6.29297 5.5C6.29297 5.295 6.46297 5.125 6.66797 5.125C6.87297 5.125 7.04297 5.295 7.04297 5.5L7.04297 8ZM6.20797 3.81C6.23297 3.745 6.26797 3.695 6.31297 3.645C6.36297 3.6 6.41797 3.565 6.47797 3.54C6.53797 3.515 6.60297 3.5 6.66797 3.5C6.73297 3.5 6.79797 3.515 6.85797 3.54C6.91797 3.565 6.97297 3.6 7.02297 3.645C7.06797 3.695 7.10297 3.745 7.12797 3.81C7.15297 3.87 7.16797 3.935 7.16797 4C7.16797 4.065 7.15297 4.13 7.12797 4.19C7.10297 4.25 7.06797 4.305 7.02297 4.355C6.97297 4.4 6.91797 4.435 6.85797 4.46C6.73797 4.51 6.59797 4.51 6.47797 4.46C6.41797 4.435 6.36297 4.4 6.31297 4.355C6.26797 4.305 6.23297 4.25 6.20797 4.19C6.18297 4.13 6.16797 4.065 6.16797 4C6.16797 3.935 6.18297 3.87 6.20797 3.81Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a8f14d163903541a3521d59bdb5ce1c7.svg";
export { ForwardRef as ReactComponent };